import rafThrottle from './raf-throttle'

export default function(events) {
  events.forEach((eventName) => {
    let optimizedEventName = `optimized${eventName[0].toUpperCase()}${eventName.slice(1)}`
    rafThrottle(eventName, optimizedEventName)
  })
}
